module ContractsPageModel

open FSharpPlus
open Elmish
open Elmish.Bridge
open Model
open PortalLibs.Client.Components
open Shared
open PortalLibs.Client.Util
open PortalLibs.Shared.NewTable

type ContractsPageViewColumn =
  | Company
  | Contract
  | ProjectManager
  | CurrentAmount
  | InterestedParties
  | Follow

type Model =
  { SearchboxValue: string option
    Contracts: ContractShort list option
    TableState: NewTableNext.Model<ContractShort, ContractsPageViewColumn, unit>
    Active: bool option }

type Msg =
  | Contracts of ContractShort list
  | SearchboxValueChanged of string option
  | TableMsg of NewTableNext.Msg<ContractShort, ContractsPageViewColumn, unit>
  | ContractFollowChanged of ContractShort
  | ContractInterestedPartiesChanged of ContractShort
  | ContractFollowMassChanged of (ContractId list * bool)
  | ActiveChanged of bool option

let init () =
  { SearchboxValue = None
    Contracts = None
    TableState = { (NewTableNext.init None) with Sort = Some(Sort.Desc ContractsPageViewColumn.CurrentAmount) }
    Active = Some true },
  Cmd.none

let requestData model =
  if Option.isNone model.Contracts then
    RSSuperUserContracts {| Active = true |}
    |> Bridge.Send

let updateContract model (contractChanged: ContractShort) =
  { model with
      Contracts =
        match model.Contracts with
        | None -> None
        | Some contracts ->
          contracts
          |>> (fun contract ->
            if contract.Id = contractChanged.Id then
              contractChanged
            else
              contract)
          |> Some }

let update msg model =
  match msg with
  | SearchboxValueChanged searchValue -> { model with SearchboxValue = searchValue }, Cmd.none
  | Contracts contracts -> { model with Contracts = Some contracts }, Cmd.none
  | TableMsg msg ->
    let newModel, newCmd, _externalMsg =
      NewTableNext.update msg model.TableState

    { model with TableState = newModel },
    Cmd.map TableMsg newCmd

  | ContractFollowChanged contract ->
    Bridge.Send(RSContractFollowChanged contract)
    updateContract model contract, Cmd.none

  | ContractInterestedPartiesChanged contract ->
    Bridge.Send(RSContractInterestedPartiesChanged contract)
    updateContract model contract, Cmd.none
  | ContractFollowMassChanged (ids, followed) ->
    Bridge.Send(RSContractFollowMassChanged(ids, followed))

    { model with
        Contracts =
          model.Contracts
          |>> (fun contracts ->
            contracts
            |>> (fun contract ->
              if List.contains contract.Id ids then
                { contract with Followed = followed }
              else
                contract)) },
    Cmd.none
  | ActiveChanged valueOpt ->
    RSSuperUserContracts {| Active = valueOpt |> Option.defaultValue false |}
    |> Bridge.Send

    { model with
        Active = valueOpt
        TableState = NewTableNext.resetModel model.TableState
        Contracts = None },
    Cmd.none

let getScrollValue () = getTableScrollPos ()

let restoreScrollPos pos = scrollTableToPos pos
